export const getStyleIconeCircular = (backgroundColor: string): Object => {
    const style = {
      backgroundColor: backgroundColor,
      width: 55,
      height: 55,
      borderRadius: "50%",
      textAlign: "center",
      display: "flex",
      alignItems: "center",
      justifyContent: "center",
    };
    return style;
};